import React, { Component } from 'react';
import './Password.css'
import Util from '../../../util';
import { Toast } from 'antd-mobile/lib';
let tipText='密码必须是6至8位的字母或数字组合且不能完全重复'
export default class Password extends Component {
  constructor(props){
    super(props);
    this.state = {
      isShow:true
    };
  }
  onKeyup(e){
    let _this=this.props._this;
    // let pattern = Util.passwordPattern;
    if (e.keyCode != 13) {
      return;
    }
    // if(!pattern.test(_this.state.keyPasswordVal)){
    //   Toast.info(tipText, 2);
    //   return;
    // }
    e.keyCode === 13 && _this.keyOk();
  }
  pwdIsOk(){
    let _this=this.props._this;
    // let pattern = Util.passwordPattern;
    // if(!pattern.test(_this.state.keyPasswordVal)){
    //   Toast.info(tipText, 2);
    //   return;
    // }
    _this.keyOk();
  }
  render(){
    let _this=this.props._this;
    return (
        <div className={this.props.ztFlag === true ? "password-sec-box" : "password-box"} >
          <div >
            <div >
              交易密码
              <img src={require('../../../img/close.png')}  onClick={()=>{_this.setState({pwdFlag:false})}}/>
              <span className='red-t' onClick={()=>{this.pwdIsOk()}} > 确认</span>
            </div>
            {
              this.props._type == "ZT" ?
              <div className='password-tip'>
                {_this.props.fundRisk?this.props.ztFlag===true ? '温馨提示：本人已完成风险测评问卷，并对申请购买的基金产品风险等级高于本人的风险承受能力情况已知晓，并已充分了解该基金产品的风险特征和可能的不利后果。本人仍坚持自愿投资该基金产品，并自愿承担由此可能产生的一切不利后果和损失。基金募集机构及工作人员在销售过程中，不存在直接或间接主动向本人推介该基金产品或服务的行为。' : '温馨提示：您购买产品的风险等级高于自身的风险承受能力，请充分了解投资风险，并确定符合您的投资目标。':''}
              </div>
              :
              <div className='password-tip'>
                {_this.props.location.state.fundRisk?'温馨提示：您购买产品的风险等级高于自身的风险承受能力，请充分了解投资风险，并确定符合您的投资目标。':''}
              </div>
            }
            <div className='password-input'>
              <input autocomplete="off"  onChange={(e)=>_this.onChangePwd(e.target.value)}  autofocus="autofocus"  type={this.state.isShow ?"password":"text"}  placeholder=""/>
              <img alt="" onClick={()=>this.setState({isShow:!this.state.isShow})} src={ this.state.isShow ? require('../../../imgs/unshow_grey@3x.png') : require('../../../imgs/show_grey@3x.png')}></img>
            </div>
          </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/myAssets/payment/Password.js